import AdRepositioner from './ad-repositioner.js';

class AdManager {
	init() {
		if (
			typeof bi_ad_settings === 'undefined' ||
			typeof bi_theme.environment === 'undefined'
		) {
			return;
		}

		if (bi_theme.environment === 'de') {
			this.moveAds();
		}

		if (bi_theme.environment === 'nl') {
			// Reposition ads in article body on mobile
			AdRepositioner.reposition(
				'div-gpt-ad-456245625425492648-1',
				['P'],
				5,
				1024,
			);
			AdRepositioner.reposition('bbw-outstreamcontainer', ['P'], 2, 1024);
			AdRepositioner.reposition('related-video', ['P'], 7, 1024);

			// Switch ad positions on certain breakpoint
			AdRepositioner.switchAds(
				'div-gpt-ad-25613-7',
				'div-gpt-ad-25613-3',
				1024,
			);
		}
	}

	moveAds() {
		// Mobile only
		if (window.screen.width < 1024) {
			// Insert mrec on pages after 4th article teaser
			jQuery('.page-template')
				.find('.article-grid__item', 'article')
				.each(function (i) {
					if (i === 4) {
						jQuery('.bi-mrec').insertAfter(this);
					}
				});

			// Insert mrec on archives after 4th article teaser
			jQuery('.archive')
				.find('.article-grid__item', 'article')
				.each(function (i) {
					if (i === 4) {
						jQuery('.bi-mrec').insertAfter(this);
					}
				});
		}
	}

	isParagraphOrSlideshow(element) {
		// Don't count empty elements by using this.innerText.trim()
		if (
			(element.nodeName === 'P' && element.innerText.trim()) ||
			(element.nodeName === 'BUTTON' && element.innerText.trim())
		) {
			return true;
		}

		return false;
	}

	changeInArticleOutbrainAds() {
		jQuery('article.article-main')
			.find('.OUTBRAIN')
			.each(function (index, element) {
				const adId = jQuery(element).data('widget-id');

				// Replace AR_5 and AR_7 ads with AR_4
				if (adId === 'AR_5' || adId === 'AR_7') {
					jQuery(element).replaceWith(
						'<div class="OUTBRAIN" data-src="' +
							window.bi_theme.permalink +
							'" data-widget-id="AR_4"></div>',
					);
					return;
				}

				// Don't touch MB_3 ads
				if (adId === 'MB_3') {
					return;
				}

				// Remove all other ads
				jQuery(element).remove();
			});
	}

	changeInArticleApesterAds() {
		window.__noApesterAds = true;
	}

	removeForbiddenAdScripts() {
		jQuery('*[data-sp-name="connatix"]').remove();
		jQuery('*[data-sp-name="nativendo"]').remove();
	}

	removeAd(target) {
		jQuery(target).remove();
	}

	maybeLoadOutbrain() {
		// Load Outbrain script
		const outbrain = document.createElement('script');
		outbrain.src = 'https://widgets.outbrain.com/outbrain.js';
		outbrain.defer = true;

		// Set attributes for SourcePoint to load the scripts after consent
		outbrain.setAttribute('type', 'text/plain');
		outbrain.setAttribute('data-sp-type', 'blocked-script');
		outbrain.setAttribute('data-sp-name', 'outbrain');

		document.body.appendChild(outbrain);
	}

	maybeLoadConnatix() {
		// Only load Connatix when Connatix is enabled and screen width is tablet/desktop size
		if (
			bi_ad_settings.is_connatix_disabled === '1' ||
			window.innerWidth < 1024
		) {
			return;
		}

		const connatixHead = document.createElement('script');
		connatixHead.defer = true;
		connatixHead.setAttribute('type', 'text/plain');
		connatixHead.setAttribute('data-sp-type', 'blocked-script');
		connatixHead.setAttribute('data-sp-name', 'connatix');
		connatixHead.innerHTML = `
			! function(n) {
				if (!window.cnx) {
					window.cnx = {}, window.cnx.cmd = [];
					var t = n.createElement("iframe");
					t.src = "javascript:false";
					t.display = "none", t.onload = function() {
						var n = t.contentWindow.document,
						c = n.createElement("script");
						c.src = "//cd.connatix.com/connatix.player.js?cid=321a5322-0990-45ac-aa91-0fb1b377a0af", c.setAttribute("async", "1"), c.setAttribute("type", "text/javascript"), n.body.appendChild(c)
					}, n.head.appendChild(t)
				}
			}(document);
	  	`;
		document.head.appendChild(connatixHead);

		const connatixBody = document.createElement('script');
		connatixBody.defer = true;
		connatixBody.setAttribute('type', 'text/plain');
		connatixBody.setAttribute('data-sp-type', 'blocked-script');
		connatixBody.setAttribute('data-sp-name', 'connatix');
		connatixBody.setAttribute('id', 'd5027e31aad84554bd9ea67a3cac8567');
		connatixBody.innerHTML = `
			(new Image()).src = "https://capi.connatix.com/tr/si?token=e27b4643-c008-4089-b3d9-5e31a7c96a4e&cid=321a5322-0990-45ac-aa91-0fb1b377a0af";
			cnx.cmd.push(function() {
				cnx({
					playerId: "e27b4643-c008-4089-b3d9-5e31a7c96a4e"
				}).render("d5027e31aad84554bd9ea67a3cac8567");
			});
	  	`;
		document.body.appendChild(connatixBody);
	}

	maybeLoadNativendo() {
		// Only load Nativendo when Nativendo is enabled
		if (bi_ad_settings.is_nativendo_disabled === '1') {
			return;
		}

		// Load Nativendo script
		const nativendo = document.createElement('script');
		nativendo.src = 'https://d.nativendo.de/cds/delivery/init';
		nativendo.defer = true;

		// Set attributes for SourcePoint to load the scripts after consent
		nativendo.setAttribute('type', 'text/plain');
		nativendo.setAttribute('data-sp-type', 'blocked-script');
		nativendo.setAttribute('data-sp-name', 'nativendo');

		document.head.appendChild(nativendo);
	}

	maybeLoadCleverPush() {
		// Only load CleverPush when CleverPush is enabled
		if (bi_ad_settings.is_cleverpush_disabled === '1') {
			return;
		}

		const cleverpush = document.createElement('script');

		cleverpush.src =
			'https://static.cleverpush.com/channel/loader/BssgKWJo9YERkT3ZE.js';
		cleverpush.setAttribute('type', 'text/plain');
		cleverpush.setAttribute('data-sp-type', 'blocked-script');
		cleverpush.setAttribute('data-sp-name', 'cleverpush');

		// Checks if dom changes are made to the header container element, where the cleverpush banner is prepended.
		const placeholder = document.getElementById('cleverpush-placeholder');
		if (placeholder) {
			const headerContainer = placeholder.parentNode;
			const config = { childList: true };

			const observer = new MutationObserver((mutations) => {
				mutations.forEach((mutation) => {
					mutation.addedNodes.forEach((node) => {
						if (
							node.id === 'cleverpush-app-download-banner-BssgKWJo9YERkT3ZE'
						) {
							headerContainer.removeChild(placeholder);
						}
					});
				});
			});

			observer.observe(headerContainer, config);
		}

		document.body.appendChild(cleverpush);
	}

	maybeLoadApester() {
		// Only load Apester when Apester is enabled.
		if (bi_ad_settings.is_apester_disabled === '1') {
			return;
		}

		// Load Apester scripts
		const apester1 = document.createElement('script');
		apester1.src = 'https://sdk.apester.com/web-sdk.core.min.js';
		apester1.defer = true;

		const apester2 = document.createElement('script');
		apester2.src = 'https://sdk.apester.com/web-sdk.core.legacy.min.js';
		apester2.noModule = true;
		apester2.defer = true;

		// Set attributes for SourcePoint to load the scripts after consent
		apester1.setAttribute('type', 'text/plain');
		apester1.setAttribute('data-sp-type', 'blocked-script');
		apester1.setAttribute('data-sp-name', 'apester');
		apester1.setAttribute('data-sp-is-module', 'true');

		apester2.setAttribute('type', 'text/plain');
		apester2.setAttribute('data-sp-type', 'blocked-script');
		apester2.setAttribute('data-sp-name', 'apester');

		document.head.appendChild(apester1);
		document.head.appendChild(apester2);
	}

	getMrecPlacementsFromContent() {
		const ids = [];
		const $mrecElements = jQuery('#mrec, [id^="mrec_btf_"], #mrec_btf');

		$mrecElements.each((index, elem) => {
			const $elem = jQuery(elem);

			if ($elem.attr('id')) {
				ids.push($elem.attr('id'));
			}
		});
		return ids;
	}
}

const instance = new AdManager();
export default instance;
